/** @jsx jsx */
import { css, jsx } from "@emotion/core"

interface IFlexProps {
  children: React.ReactNode
  className?: string
  alignItems?: "start" | "end" | "center" | "stretch" | "baseline"
  justifyContent?: "start" | "end" | "center" | "space-between" | "space-around"
  gap?: number
  wrap?: boolean
  direction?: "row" | "column" | "row-reverse" | "column-reverse"
}

export function Flex({
  children,
  className,
  alignItems,
  justifyContent,
  gap,
  wrap,
  direction,
}: IFlexProps) {
  return (
    <div
      css={css({
        display: "flex",
        alignItems,
        justifyContent,
        gap,
        flexWrap: wrap ? "wrap" : "initial",
        flexDirection: direction,
      })}
      className={className}
    >
      {children}
    </div>
  )
}

Flex.Spacer = function () {
  return (
    <div
      css={css`
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 0;
        min-width: 0;
      `}
    />
  )
}
